export const GET_LEVELS = "GET_LEVELS";
export const GET_LEVEL_BY_ID = "GET_LEVEL_BY_ID";
export const UPDATE_LEVEL = "UPDATE_LEVEL";
export const DELETE_LEVEL = "DELETE_LEVEL";
export const CREATE_LEVEL = "CREATE_LEVEL";
export const GET_PROGRAMS_BY_LEVEL = "GET_PROGRAMS_BY_LEVEL";
